import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="pt-12 pb-16 px-4 bg-white text-center" data-id="element-75">
      <div className="max-w-5xl mx-auto" data-id="element-76">
        <p className="text-red-600 font-bold tracking-widest uppercase mb-4 text-sm md:text-base" data-id="element-77">
          🧠 SECCIÓN 1 — ATENCIÓN
        </p>
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-black leading-[1.1] mb-8 uppercase" data-id="element-78">
          De no vender nada… a generar{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-600 to-red-800" data-id="element-79">
            ingresos constantes
          </span>{' '}
          en 30 días
          <br data-id="element-80" />
          <span className="text-2xl md:text-4xl lg:text-5xl text-gray-700 mt-4 block normal-case font-extrabold" data-id="element-81">
            (aunque hoy estés perdido y no sepas por dónde empezar)
          </span>
        </h1>

        <a href="https://valordigital.store/cart/46518849142973:1" target="_blank" rel="noopener noreferrer" className="block max-w-2xl mx-auto mb-8 hover:scale-[1.02] transition-transform cursor-pointer" data-id="element-82">
          <img src="https://cdn.magicpatterns.com/uploads/tmUaesdN5rA7exdC7E5KLM/TOMO_1_MEGAPACK_DE_0_A_VENTAS.png" alt="Megapack De 0 a Ventas en 30 Días" className="w-full h-auto rounded-xl shadow-2xl border-4 border-gray-200" data-id="element-83" />
        </a>

        <h2 className="text-xl md:text-3xl font-bold text-gray-800 max-w-4xl mx-auto mb-10 leading-snug bg-yellow-100 p-6 rounded-lg border-l-8 border-yellow-400" data-id="element-84">
          Un sistema simple, probado y accionable para transformar tu contenido,
          tus conversaciones y tu día a día en ventas reales.
        </h2>

        <CTAButton text="QUIERO EMPEZAR AHORA" data-id="element-85" />
      </div>
    </section>;
}